// removed by extract-text-webpack-plugin
module.exports = {"main":"_3Wim6ADm5sWzZydRwgdpeo"};


//////////////////
// WEBPACK FOOTER
// ./components/Reset.module.css
// module id = 2370
// module chunks = 1